import { inject, Injectable } from '@angular/core';
import { CommonService } from '@geneplanet/ngx-shop/src/lib/shared';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

/**
 * Custom translate service will convert LocationCode to LanguageCode.
 * This is to make sure TranslateService will always have language, not location.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomTranslateService extends TranslateService {
  private commonService = inject(CommonService);

  public setFallbackLang(lang: string) {
    return super.setFallbackLang(
      this.commonService.getLanguageCodeFromLocationCode(lang)
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public use(lang: string): Observable<any> {
    return super.use(this.commonService.getLanguageCodeFromLocationCode(lang));
  }
}
